<header>
    <h2>{{ formTitle }}</h2>
    <p *ngIf="!resetPasswordFail && !resetPasswordSuccess">{{ formInstruction }}</p>
  </header>
  <form *ngIf="!resetPasswordSuccess" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(f)" #f="ngForm">
    <div class="password">
      <mat-form-field class="auth-input reset-password-input" appearance="outline">
        <input matInput placeholder="Enter new password" [formControlName]="'password'" [type]="hide ? 'password' : 'text'"
          (ngModelChange)="onInputChange(f)" (blur)="onBlur(f)" data-automation-id="input_newPassword">
        <button mat-icon-button matSuffix (click)="toggleHide()" type="button">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="password-confirm">
      <mat-form-field class="auth-input reset-password-input" appearance="outline">
        <input matInput placeholder="Confirm password" [formControlName]="'confirmPassword'" [type]="hide ? 'password' : 'text'"
          (ngModelChange)="onInputChange(f)" (blur)="onBlur(f)" data-automation-id="input_confirmPassword">
        <button mat-icon-button matSuffix (click)="toggleHide()" type="button">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div *ngIf="resetPasswordFail">
      <mat-error>
        {{resetFailText}}
      </mat-error>
    </div>
    <p *ngIf="resetPasswordSuccess" class="t-light">Password reset completed. click <a href="/auth/signin">here</a> to sign in to the Adminis control panel.</p>
    <div class="modal-buttons">
      <button class="a-rounded-button a-rounded-button--primary" type="submit" [disabled]="!f.valid" data-automation-id="btn_resetPasswordNext">Next</button>
      <button [routerLink]="['/auth/signin']" class="a-rounded-button a-rounded-button--primary-outline">Cancel</button>
    </div>
  </form>